export default () => ({
  post__stat: {
    margin: '0 0.4rem',
    fontSize: '0.8rem',
  },
  post__stat__icon: {
    fontSize: '0.4rem',
  },
});
